import React, { ReactElement } from 'react';

import { GlobalConfig } from '@digital-dealer/brand-theming';
import { textsService } from '@digital-dealer/texts-service';

import RoutingRules from './routingRules';
import textsOverride from './configs/textsOverride';

textsService.override(textsOverride);

const App = (): ReactElement => (
  <GlobalConfig>
    <RoutingRules />
  </GlobalConfig>
);

export default App;
